import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HyperlinkComponent } from '@app/main/hyperlinks/hyperlink.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [{ path: '', component: HyperlinkComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HyperlinksRoutingModule {}
